// extracted by mini-css-extract-plugin
export default {"languageCurrencyGroup":"k99mCc","currencyDropdown":"Rav39t","disabled":"lFbWJu"};